<script>
export default {
  props: {
    etapas:     { type: Array,  default: () => [] },
    atual:      { type: Number, default: 1 },
    concluidas: { type: Array,  default: () => [] },
  },
  methods: {
    isConcluida(n) { return this.concluidas.includes(n) },
    isAtual(n)     { return n === this.atual },
    isClicavel(n)  { return this.isConcluida(n) || this.isAtual(n) },
    clicar(n) {
      if (this.isClicavel(n)) this.$emit('ir-para', n)
    },
  },
}
</script>

<template>
  <ol class="stepper" aria-label="Etapas do cadastro">
    <li
      v-for="(etapa, idx) in etapas"
      :key="etapa.numero"
      class="stepper__item"
      :class="{
        'stepper__item--current': isAtual(etapa.numero),
        'stepper__item--done':    isConcluida(etapa.numero),
      }"
    >
      <span
        v-if="idx > 0"
        class="stepper__connector"
        :class="{ 'stepper__connector--done': isConcluida(etapas[idx - 1].numero) }"
        aria-hidden="true"
      />

      <button
        type="button"
        class="stepper__dot"
        :aria-current="isAtual(etapa.numero) ? 'step' : null"
        :disabled="!isClicavel(etapa.numero)"
        @click="clicar(etapa.numero)"
      >
        <svg v-if="isConcluida(etapa.numero) && !isAtual(etapa.numero)" width="14" height="14" viewBox="0 0 16 16" fill="none">
          <path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span v-else>{{ etapa.numero }}</span>
      </button>

      <span class="stepper__label">{{ etapa.label }}</span>
    </li>
  </ol>
</template>

<style scoped lang="scss">
@import "~@/design/tokens";

.stepper {
  list-style: none;
  padding: 0;
  margin: 0 0 $space-5;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.stepper__item {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 0 2px;
}

// Linha conectora horizontal entre as bolinhas (à esquerda do item, exceto o primeiro)
.stepper__connector {
  position: absolute;
  top: 15px;            // metade da altura do dot (32 / 2 - meia espessura)
  right: 50%;           // começa no centro do item atual
  width: 100%;          // até o centro do item anterior (espelhado pela posição relativa)
  height: 2px;
  background: $border-input;
  z-index: 0;
}

.stepper__connector--done {
  background: $brand-primary;
}

.stepper__dot {
  position: relative;
  z-index: 1;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid $border-input;
  background: $bg-card;
  color: $text-muted;
  font-weight: 700;
  font-size: .85rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  flex-shrink: 0;
  transition: background .15s, border-color .15s, color .15s, box-shadow .15s;
  padding: 0;
  font-family: inherit;
}

.stepper__dot:not(:disabled) { cursor: pointer; }

.stepper__item--current .stepper__dot {
  background: $brand-primary;
  border-color: $brand-primary;
  color: $text-on-brand;
  box-shadow: 0 0 0 4px rgba(34, 87, 110, .15);
}

.stepper__item--done:not(.stepper__item--current) .stepper__dot {
  background: $brand-primary;
  border-color: $brand-primary;
  color: $text-on-brand;
}

.stepper__label {
  margin-top: $space-2;
  font-size: .65rem;
  line-height: 1.2;
  color: $text-muted;
  text-align: center;
  word-break: break-word;
  max-width: 100%;
}

.stepper__item--current .stepper__label {
  color: $text-strong;
  font-weight: 600;
}

.stepper__item--done:not(.stepper__item--current) .stepper__label {
  color: $brand-primary;
}

@media (min-width: $bp-sm) {
  .stepper__label { font-size: .82rem; }
}

@media (min-width: $bp-md) {
  .stepper { margin-bottom: $space-6; }
  .stepper__label { font-size: .9rem; }
}
</style>
